export const state = {
  auditLogging: {
    dataTime: '',
    dataSource: '',
    level: '',
    objectSource: '',
    eventId: '',
    detail: '',
    checked: false
  },
  auditLoggings: [],
  searchvalue: '',
  searchStartDateTime: '',
  searchEndDateTime: '',
  findAuditLoggings: [],
  message: '',
  exportData: [],
  total: 0,
  selectedLogList: []
}
const levelList = [
  {id: 1, name: 'ERROR'},
  {id: 2, name: 'WARN'},
  {id: 3, name: 'INFO'},
  {id: 4, name: 'DEBUG'}
]
const dataSourceList = [
  {id: 1, name: 'ログイン'},
  {id: 2, name: 'ログアウト'},
  {id: 3, name: 'API呼び出し'},
  {id: 4, name: 'ログアウト(自動)'},
  {id: 5, name: 'パスワード変更'},
  {id: 6, name: '初期パスワード変更'},
  {id: 7, name: 'ステータス設定'},
  {id: 9, name: 'その他'}
]
const objectSourceList = [
  {id: 'A', name: 'アプリ'},
  {id: 'B', name: 'API'},
  {id: 'C', name: '管理パネル'}
]
export const mutations = {
  setAuditLoggings(state, response) {
    if (response.data['data'] === null) {
      response.data['data'] = []
      state.total = 0
    }
    for (var i = 0; i < response.data['data'].length; i++) {
      response.data['data'][i]['level'] = levelList.find(
        level => level.id === response.data['data'][i]['level']
      ).name
      response.data['data'][i]['dataSource'] = dataSourceList.find(
        dataSource => dataSource.id === response.data['data'][i]['dataSource']
      ).name
      response.data['data'][i]['objectSource'] = objectSourceList.find(
        objectSource =>
          objectSource.id === response.data['data'][i]['objectSource']
      ).name

      response.data['data'][i]['index'] = i
      var date = new Date(response.data['data'][i]['dataTime'])
      response.data['data'][i]['dataTime'] =
        date.getFullYear() +
        '/' +
        (date.getMonth() + 1) +
        '/' +
        date.getDate() +
        ' ' +
        date.toLocaleTimeString()
      if (
        state.selectedLogList.some(
          selectedLog => selectedLog.id === response.data['data'][i]['id']
        )
      ) {
        response.data['data'][i]['checked'] = true
      } else {
        response.data['data'][i]['checked'] = false
      }
    }
    state.auditLoggings = response.data['data']
    state.message = response.data['header'].message
    state.total = response.data['header']['total']
  },
  setExportData(state, response) {
    for (var i = 0; i < response.data['data'].length; i++) {
      let date = new Date(response.data['data'][i]['dataTime'])
      response.data['data'][i]['dataTime'] =
        date.getFullYear() +
        '/' +
        (date.getMonth() + 1) +
        '/' +
        date.getDate() +
        ' ' +
        date.toLocaleTimeString()
      response.data['data'][i]['level'] = levelList.find(
        level => level.id === response.data['data'][i]['level']
      ).name
      response.data['data'][i]['dataSource'] = dataSourceList.find(
        dataSource => dataSource.id === response.data['data'][i]['dataSource']
      ).name
      response.data['data'][i]['objectSource'] = objectSourceList.find(
        objectSource =>
          objectSource.id === response.data['data'][i]['objectSource']
      ).name
    }
    state.exportData = response.data['data']
  },
  clearExportData(state) {
    state.exportData = []
  },
  setDetail(state, response) {
    for (var i in response.data['data']) {
      if (response.data['data'][i] === null) {
        response.data['data'][i] = ''
      }
    }
    state.auditLogging = response.data['data'][0]
  },
  inputUpdate(state, payload) {
    state.auditLogging[payload.name] = payload.value
  },
  clearAuditLoggings(state) {
    for (var i in state.auditLogging) {
      state.auditLogging[i] = ''
    }
  },
  searchvalue(state, payload) {
    state.searchvalue = payload
  },
  searchStartDateTime(state, payload) {
    state.searchStartDateTime = payload
  },
  searchEndDateTime(state, payload) {
    state.searchEndDateTime = payload
  },
  changeFindAuditLoggings(state, payload) {
    state.findAuditLoggings = payload
  },
  updateSelectedLogList(state, payload) {
    for (var i = 0; i < payload.length; i++) {
      if (
        payload[i].checked &&
        !state.selectedLogList.some(log => log.id === payload[i].id)
      ) {
        state.selectedLogList.push(payload[i])
      } else if (
        !payload[i].checked &&
        state.selectedLogList.some(log => log.id === payload[i].id)
      ) {
        const deleteIndex = state.selectedLogList.findIndex(
          log => log.id === payload[i].id
        )
        state.selectedLogList = state.selectedLogList.toSpliced(deleteIndex, 1)
      }
    }
  },
  clearSelectedLogList(state) {
    state.selectedLogList = []
  }
}
export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/auditLoggingModules/auditLoggingMutation.js